import React from 'react';
import { images } from '../../constants';

const SubHeading = ({ title, globalRating }) => (
    <div style={{ marginBottom: '1rem' }}>
        <p className="p__cormorant" style={{ color: '#FF7373' }}>
            {title} {globalRating && `(${globalRating})`}
        </p>
        <img src={images.chopstickSide} alt="spoon_image" className="chopstick__img" style={{ filter: 'invert(0.5) sepia(1) saturate(5) hue-rotate(-40deg)'}} />
    </div>
);

export default SubHeading;